module.exports = __webpack_public_path__ + "img/right.31913fde.png";